import { createSvgIcon } from '@mui/material/utils';
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsx("path", {
  d: "M11.562 5.732A2.5 2.5 0 0 1 13.329 5h4.172a1.5 1.5 0 0 1 1.5 1.5v4.172a2.5 2.5 0 0 1-.732 1.767l-6.5 6.5a2.5 2.5 0 0 1-3.536 0l-3.171-3.171a2.5 2.5 0 0 1 0-3.536zM16 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
}), 'DiscountTagFilled');
//# sourceMappingURL=index.js.map